<template>
 <div class="allOrder">
 	<mt-header :title="state==1?'待付款':state==2?'交易中':state==3?'待发货':state==4?'待收货':state==5?'交易成功':state==6?'交易关闭':'全部订单'"  fixed>
		  <a href="javascript:void(0)" slot="left" @click="returnBack">
		    <mt-button icon="back" class="font-Yahei"></mt-button>
		  </a>
		  <a href="/" slot="right">
		    <mt-button><img src="../../../static/images/go_home_ico.png" width="23"/></mt-button>
		  </a>
 	</mt-header>
 	<div class="mt40">
 		<div v-infinite-scroll="loadMore" infinite-scroll-disabled="loading" infinite-scroll-distance="10">
 		 <orderData :orderData="orderList" :states="state"></orderData>
 		 <p v-if="orderListlength==0" class="mt100 text-center font-size9 line-height25 bgfff colora9a9a9"><span class="colord6d6d6 mr10">———</span>目前还没有{{state==1?'待付款的':state==2?'交易中的':state==3?'待发货的':state==4?'待收货的':state==5?'交易成功的':state==6?'交易关闭的':'相应'}}订单<span class="colord6d6d6 ml10">———</span></p>
 		 <p v-show="loadingTextBtn==false && orderList.length>3" class="text-center font-size7 heightmargin bgf3f3f3 colord6d6d6"><span class="colord6d6d6 mr10">——————</span>我是有底线的<span class="colord6d6d6 ml10">——————</span></p>
 		 <div class="loading-text" v-show="loadingTextBtn==true">
 		 	<span class="text-center inline-block mt5">
 		 		<label v-text="loadingText" class="float-left font-size7"></label>
 		 		<mt-spinner class="float-left ml5" v-show="loadingComplete==false" type="snake" :size="10"></mt-spinner>
 		 	</span>
 		 </div>
 		</div>
 	</div>
 	<!-- 待付款
 	<p v-show="state==1"><input type="button" value="一键支付" class="btnkeypay"/></p>-->
 </div>
</template>

<script>
 import orderData from '@/components/orderList'
 export default{
 	components:{
	   orderData,
	},
  	data(){
		return{
			username:localStorage.getItem("username"),
			orderList:[],
			state:this.$route.query.state,
			page:1,
			totalPages:"",
			loadingTextBtn:"",
            loadingText:"加载中",
            loading:false,
            loadingComplete:false,
            orderListlength:-1
		}
	},
	created:function(){
		this.orderListQuery();
		localStorage.setItem("listState",this.state);//保存订单状态
	},
	methods: {
		returnBack(){
	       	this.$router.push({path: '/UserCenter'});
	    },
	    //查询不同状态订单信息
	    orderListQuery(){
	      this.$http.post(this.URL_PREFIX+"/order/findOrderByState.net",{phone:this.username,state:this.state,page:this.page,rows:10})
	  	  .then((res) =>{
	  	  	this.orderList=res.data.rows;
//	  	  	console.log('订单列表');
//	  	  	console.log(res.data.rows);
	  	  	this.orderListlength=res.data.rows.length;
	  	  	this.totalPages=res.data.pageSize;
	  	  });
	    },
	    //加载更多
	    loadMore(){
	      this.loading = true;
	      setTimeout(() => {
	      this.loadingTextBtn=true;
          this.page++;
          if(this.page<=this.totalPages){
            this.$http.post(this.URL_PREFIX+"/order/findOrderByState.net",{phone:this.username,state:this.state,page:this.page,rows:10})
	  	    .then((res) =>{
	  	  	     this.orderList=this.orderList.concat(res.data.rows);
	  	  	     this.orderListlength=this.orderList.concat(res.data.rows).length;
	  	  	     //console.log(this.orderList.concat(res.data.rows).length);
//	  	  	     console.log('全部订单');
//	  	  	     console.log(this.orderList.concat(res.data.rows));
	  	    });
          }else{
            this.loadingText="";
            this.loadingComplete=true;
            this.loadingTextBtn=false;
          }
            this.loading = false;
            
        }, 2500);
	    }
	}
  }
</script>

<style scoped="scoped">
.loading-text{text-align: center;color: #666;font-size: 0.8rem;}
.heightmargin{height: 25px;}
</style>


// WEBPACK FOOTER //
// src/views/Order/orderList.vue